const initialState = {
  shift: null,
  shiftHydrated: false,
  heldSales: [],
  heldHydrated: false,
  salesHydrated: false,
};

function roundMoney(value) {
  return Math.round((Number(value) || 0) * 100) / 100;
}

function tenderOf(paymentType) {
  if (paymentType == null || String(paymentType).trim() === "" || String(paymentType).toLowerCase() === "null") {
    return "cash";
  }
  const t = String(paymentType).trim().toLowerCase().replace(/ /g, "_");
  if (t.includes("card")) return "card";
  if (t.includes("bank") || t.includes("transfer")) return "bank";
  return "cash";
}

function expectedCash(shift) {
  return roundMoney(
    Number(shift?.openingFloat || 0) + Number(shift?.cashSales || 0) - Number(shift?.cashRefunds || 0)
  );
}

function applySale(shift, amount, paymentType) {
  if (!shift) return shift;
  const next = { ...shift };
  const tender = tenderOf(paymentType);
  const add = roundMoney(amount);
  if (tender === "card") next.cardSales = roundMoney(Number(next.cardSales || 0) + add);
  else if (tender === "bank") next.bankSales = roundMoney(Number(next.bankSales || 0) + add);
  else next.cashSales = roundMoney(Number(next.cashSales || 0) + add);
  next.ticketCount = Number(next.ticketCount || 0) + 1;
  next.expectedCash = expectedCash(next);
  return next;
}

function applyRefund(shift, amount, paymentType) {
  if (!shift) return shift;
  const next = { ...shift };
  const tender = tenderOf(paymentType);
  const add = roundMoney(amount);
  if (tender === "card") next.cardRefunds = roundMoney(Number(next.cardRefunds || 0) + add);
  else if (tender === "bank") next.bankRefunds = roundMoney(Number(next.bankRefunds || 0) + add);
  else next.cashRefunds = roundMoney(Number(next.cashRefunds || 0) + add);
  next.refundCount = Number(next.refundCount || 0) + 1;
  next.expectedCash = expectedCash(next);
  return next;
}

function heldId(order) {
  return String(order?.orderId || order?.id || "").trim();
}

export default function hposTillReducer(state = initialState, action) {
  switch (action.type) {
    case "HPOS_SET_SHIFT":
      return {
        ...state,
        shift: action.shift || null,
        shiftHydrated: true,
      };
    case "HPOS_CLEAR_SHIFT":
      return {
        ...state,
        shift: null,
        shiftHydrated: true,
      };
    case "HPOS_APPLY_SALE":
      if (!state.shift) return state;
      return {
        ...state,
        shift: applySale(state.shift, action.amount, action.paymentType),
      };
    case "HPOS_APPLY_REFUND":
      if (!state.shift) return state;
      return {
        ...state,
        shift: applyRefund(state.shift, action.amount, action.paymentType),
      };
    case "HPOS_SET_HELD_SALES":
      return {
        ...state,
        heldSales: Array.isArray(action.heldSales) ? action.heldSales : [],
        heldHydrated: true,
      };
    case "HPOS_UPSERT_HELD_SALE": {
      const order = action.order;
      const id = heldId(order);
      if (!id) return state;
      const rest = (state.heldSales || []).filter((row) => heldId(row) !== id);
      return {
        ...state,
        heldSales: [order, ...rest],
        heldHydrated: true,
      };
    }
    case "HPOS_REMOVE_HELD_SALE": {
      const id = String(action.orderId || "").trim();
      if (!id) return state;
      return {
        ...state,
        heldSales: (state.heldSales || []).filter((row) => heldId(row) !== id),
      };
    }
    case "HPOS_SALES_HYDRATED":
      return { ...state, salesHydrated: true };
    default:
      return state;
  }
}
